import { mockComponentRenderProp } from 'bloko/common/setupMockComponents';

export default mockComponentRenderProp('DropBase', null, { withChildren: true });
